<template>
  <div>
    <div class="mb-5">
    <!-- <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
        Email or Username
    </label> -->
    <input class="appearance-none h-10 bg-gray-200 border-0 rounded w-full py-2 px-3 text-gray-600 leading-tight sm:text-sm sm:leading-5" 
        id="username" 
        type="text" 
        placeholder="Username Or Email">
        <!-- <p class="text-red-500 text-xs italic">Please choose a password.</p> -->
    </div>
    <div class="mb-6">
    <!-- <label class="block text-gray-600 text-sm font-bold mb-2" for="password">
        Password
    </label> -->
    <input class="appearance-none h-10 bg-gray-200 border-0 rounded w-full py-2 px-3 text-gray-600 mb-3 leading-tight sm:text-sm sm:leading-5" 
        id="password" 
        type="password" 
        placeholder="******************">
    <!-- <p class="text-red-500 text-xs italic">Please choose a password.</p> -->
    </div>

    <div class="flex items-center justify-between mt-4 mb-10">
      <div class="flex items-center">
        <input class="h-4 w-4 mr-2" type="checkbox" name="rememberme" id="rememberme">
        <label for="rememberme" class="inline-block align-baseline font-bold text-sm text-gray-600">
          Remember me
        </label>
      </div>
      <a class="inline-block align-baseline font-bold text-sm text-gray-600 hover:text-gray-800" href="#">
        Forgot Password?
      </a>
    </div>

    <button-lg 
        type="submit" 
        class="text-white bg-green-500 hover:bg-green-700 outiline-none border-none uppercase">
          Login
    </button-lg>
  </div>
</template>

<script>
import ButtonLG from "@/components/ButtonLG"

export default {
  components: {
    'button-lg': ButtonLG,
  }
}
</script>